<template>
  <div>
    <RiClothesCard v-if="!fileListObject">
      <RiClothesText textSize="1.6rem">ロード中...</RiClothesText>
    </RiClothesCard>

    <RiClothesCard v-if="isError">
      <RiClothesText textSize="1.6rem">エラーが発生しました</RiClothesText>
    </RiClothesCard>

    <RiClothesCard v-if="fileListObject">
      <RiClothesText textSize="1.8rem">{{ `${fileListObject.name}の内容物` }}</RiClothesText>
    </RiClothesCard>

    <RiClothesCard v-if="fileListObject" style="margin-top: 8px; margin-bottom: 8px;">
      <RiClothesFileViewer :fileList="fileListObject.file_list"></RiClothesFileViewer>
    </RiClothesCard>
  </div>
</template>>

<script>
import RiClothesCard from "../components/RiClothesCard";
import RiClothesText from "../components/RiClothesText";
import RiClothesFileViewer from "../components/RiClothesFileViewer";

export default {
  components: {
    RiClothesCard,
    RiClothesText,
    RiClothesFileViewer
  },
  data() {
    return {
      fileListObject: null,
      isError: false
    }
  },
  mounted() {
    const paramsId = this.$route.params.id;
    if(paramsId == undefined) {
      return;
    }

    fetch(`/products/${paramsId}/file_list.json`, { method: "GET" }).then(response => response.text()).then(text => {
      this.fileListObject = JSON.parse(text);
      document.title = `${this.fileListObject.name}の内容物 - RiClothes Website`;
    }).catch(error => {
      this.isError = true;
      console.log(`Error: ${error}`);
    });
  }
}
</script>

<style lang="scss" scoped>
.riclothes-content-file {

}
</style>